import { TransactionListHeaderComponent } from "../transaction-list-header.component";
import { Component, Input } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";
import { TradableWalletListService } from "@main-services/wallet/tradable_wallet_list.service";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { Provider } from "@models/interfaces";
import { Fiat } from "@models";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";
import { Tradable } from "@models/interfaces/tradable";
import { Currency } from "@models/interfaces/currency";
import { FiatTransaction } from "@models/transaction";
import { AccountService } from "@modules/account/services/account.service";
import { FiatService } from "@main-services/currency";
import { ContactService } from "@main-services/contact.service";
import { PayAccountService } from "@main-services/pay_account.service";
import { Observable } from "rxjs";
import { PortfolioFacade } from "@modules/portfolio/domain/portfolio.facade";

@Component({
	selector: "fiat-transaction-list-header",
	templateUrl: "./fiat-transaction-list-header.component.html",
	standalone: false
})
export class FiatTransactionListHeaderComponent extends TransactionListHeaderComponent {
	@Input() public transaction: FiatTransaction = null;

	public isHideValueActive$: Observable<boolean> = this.portfolioFacade.isPortfolioDataHidden$;

	public constructor(
		protected modalService: ModalService,
		protected tradableWalletListService: TradableWalletListService,
		protected tradableListService: TradableListService,
		protected accountService: AccountService,
		protected fiatWalletService: FiatWalletService,
		protected fiatService: FiatService,
		protected contactService: ContactService,
		protected masterdataService: MasterdataService,
		protected translationService: TranslationService,
		protected payaccountService: PayAccountService,
		private readonly portfolioFacade: PortfolioFacade
	) {
		super(
			modalService,
			tradableWalletListService,
			tradableListService,
			fiatWalletService,
			fiatService,
			contactService,
			masterdataService,
			payaccountService,
			translationService
		);
	}

	public getOutgoingIcon(): string {
		if (this.transaction.hasTrade() && !this.isDebitCardWithdrawal()) {
			const tradable: Tradable = this.tradableListService.getItemById(
				this.transaction.getTrade().getCurrencyId()
			);
			if (tradable) {
				return tradable.getIconCssName(true);
			}
			return "";
		}
		return "bpi__asset-" + this.fiatService.getItemById(this.transaction.getFiatId()).getSymbol(true);
	}

	public getIconCurrency(): Currency {
		if (this.transaction.hasTrade() && !this.isDebitCardWithdrawal()) {
			return this.tradableListService.getItemById(this.transaction.getTrade().getCurrencyId());
		}
		return this.fiatService.getItemById(this.transaction.getFiatId());
	}

	public isSEPAWithdrawProcessing(): boolean {
		if (this.payoutAccount) {
			return (
				this.transaction.getType() === "withdrawal" &&
				this.transaction.isStatus("processing") &&
				this.payoutAccount.getProviderId() === "1"
			);
		}
		return false;
	}

	public getRecipientPrefix(): string {
		return this.transaction.isOutgoing() ||
			this.isIncomingDividendTransaction() ||
			this.transaction.getType() === "sell"
			? "to"
			: "from";
	}

	public getRecipientInformation(): string {
		if (this.transaction.getTagShortNames().join().includes("stock_exchange")) {
			return "Bitpanda";
		}

		return this.transaction.isOutgoing() || this.isIncomingDividendTransaction()
			? this.transaction.getRecipient()
			: this.transaction.getFrom();
	}

	public isOutgoingTransfer(): boolean {
		return this.transaction.getType() === "transfer" && this.isOutgoing();
	}

	public isCardOrderingFee(): boolean {
		const tagShortName = this.transaction.getTagShortNames()[0];
		return tagShortName ? tagShortName.includes("card_order_charge") : false;
	}

	public isIncomingTransfer(): boolean {
		return this.transaction.getType() === "transfer" && !this.isOutgoing();
	}

	public get currencySymbol(): string {
		return this.fiatService.getItemById(this.transaction.getFiatId()).getSymbol();
	}

	public get amount(): number {
		if (!this.fiat) {
			return 0;
		}
		let isCashPlusReward: boolean = !!this.transaction
			.getTagShortNames()
			.find((item) => item === "cashplus.mmf.reward");
		if (
			this.transaction.getType() === "withdrawal" ||
			this.transaction.getType() === "deposit" ||
			isCashPlusReward
		) {
			return +this.transaction.getAmountWithoutFee();
		}

		return +this.transaction.getAmount();
	}

	public getPaymentProvider(): Provider {
		return this.masterdataService.getPaymentOptionById(this.transaction.getPaymentOptionId());
	}

	public get fiatForAmount(): Fiat {
		return this.transaction.hasTrade()
			? this.fiatService.getItemById(this.transaction.getTrade().getFiatId())
			: this.fiatService.getItemById(this.transaction.getFiatId());
	}

	public getCryptoAmountFromTrade(): string {
		if (this.transaction.hasTrade()) {
			return this.transaction.getTrade().getAmountTradable();
		}
		return "0";
	}
}
